module.exports = "<!-- Fejléc --> \n<app-header></app-header>\n\n<!-- Tartalom -->\n<app-content></app-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main